module.exports = __webpack_public_path__ + "double-forhonor-desktop.jpg";